export const displayInstallCocoparksSelector = ({displayInstallCocoparks}) => displayInstallCocoparks